/**
 * Created by Pankaj singh on 2019-10-15.
 */

import {
    IWinPresentationConfig,
    WinPresentationController
} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {RomanEmpireParsedGameData} from "../../server/data/RomanEmpireParsedGameData";
import {GenieFeatureView} from "./GenieFeatureView";
import {TimelineLite, TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";
import {RomanEmpireGameMode} from "../../gamemode/RomanEmpireGameMode";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SoundManager} from "../../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";


export interface ISymbolPositions {
    reelId: number;
    symbolId: number;
}

export interface IMultiplierPosition extends ISymbolPositions {
    value: number,
    isDisabled: boolean
}

export class GenieFeatureController extends WinPresentationController {

    private _isFeatureTriggered: boolean = false;
    private _view: GenieFeatureView;
    private _genieSymbolTriggerPositions: ISymbolPositions[] = [];
    private _timeline: TimelineLite;
    private _featureType: string;
    private _genieExtraScatter: ISymbolPositions;
    private _scatterPos: number[];
    private _genieOverlayWilds: ISymbolPositions[] = [];
    private _currentMultiplier: number;
    private _genieTimesBetCoinWin: number;
    private _isReSpin: boolean = false;
    private _multiplierOverlays: IMultiplierPosition[] = [];
    private _m2m3Pos: ISymbolPositions[] = [];
    private _symbolWinStates: boolean[][] = [];
    private _dimSymbolArr: ISymbolPositions[] = [];
    private _finishTween: TweenLite;

    constructor(indexes: [number, number], config: IWinPresentationConfig) {
        super(indexes, config);
        this._view = new GenieFeatureView();
    }

    protected addFeatureEventHandlers(): void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event: GameEvent) => this.onBeforeSpinStarted());
        //EventHandler.addEventListener(this, RomanEmpireEvents.TRANSFORM_TO_WILD, (event: GameEvent) => this.convertM2M3intoWild());
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_NO_WIN_PRESENTATION, (event: GameEvent) => this._view.dimMultiplier(event.params[0]));
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_BIG_WIN_ANIM_START, (event: GameEvent) => this.onBigWinAnimStart());
    }

    private onBigWinAnimStart(){
        this._view.resetLayer()
    }

    private convertM2M3intoWild(m2m3Pos: ISymbolPositions[]): TimelineLite {
        return this._view.startGenieWildPresentation(this._genieSymbolTriggerPositions, m2m3Pos);
    }

    private convertM2M3intoScatter(m2m3Pos: ISymbolPositions[]): TimelineLite {
        return this._view.startGenieFSPresentation(m2m3Pos);
    }

    private onBeforeSpinStarted() {
        this._view.reset();
    }

    protected hasWin(): boolean {
        return this._isFeatureTriggered;
    }

    protected parseFeatureGameData(data: RomanEmpireParsedGameData): void {
        this._isFeatureTriggered = data.isGenieFeatureTriggered;
        this.setTriggeredPositions(data.genieSymbolTriggerPositions);
        this._featureType = data.genieFeatureAwarded;
        this.setGenieOverlayWilds(data.genieOverlayWilds, data.genieSymbolTriggerPositions);
        this._genieExtraScatter = {
            reelId: data.genieExtraScatter[0],
            symbolId: data.genieExtraScatter[1]
        };
        this._scatterPos = data.scatterPositions || [];
        this._currentMultiplier = data.currentMultiplier;
        this._genieTimesBetCoinWin = data.genieTimesBetCoinWin;
        this._isReSpin = data.mode == RomanEmpireGameMode.GENIE_RESPIN;

        this._symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(RomanEmpireGameConfig.instance.REELS_NUM, () => {
            return ArrayHelper.initArrayWithValues<boolean>(RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[2], () => false)
        });
        this.updateSymbolWinStates(data);

        this.setMultiplierOverlays(data.multiplierOverlays);
        this.setM2M3Pos(data.reels);
    }


    private updateSymbolWinStates(data: RomanEmpireParsedGameData): void {
        (<IBetLineWinData[]>data?.betWins)?.forEach((betLineWinData: IBetLineWinData) => {
            for (let reelId: number = 0; reelId < betLineWinData.nrOfSymbols; reelId++) {
                const symbolId: number = betLineWinData.betLine[reelId];
                this._symbolWinStates[reelId][symbolId] = true;
            }
        });
    }

    protected resetFeature(): void {
        this._genieSymbolTriggerPositions.length = 0;
        this._genieOverlayWilds.length = 0;
    }

    protected startWinPresentation(): void {
        if (this._genieSymbolTriggerPositions.length) {
            this._timeline = new TimelineLite({paused: true});
            if (this._isReSpin) {
                this._timeline.add(this.convertM2M3intoScatter(this._m2m3Pos));
                this._timeline.add(() => {
                    EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_SCATTER_REVEAL));
                });
            } else {
                let pos: number[] = Helper.getSymbolPositions(this._genieSymbolTriggerPositions[0].reelId, this._genieSymbolTriggerPositions[0].symbolId);
                pos[0] += RomanEmpireGameConfig.instance.SYMBOL_WIDTH * 0.5;
                this._timeline.add(() => this._view.dimSymbol(this._dimSymbolArr));
                this._timeline.add([
                    this._view.getLockAnim(this._genieSymbolTriggerPositions[0]),
                    () => SoundManager.playSound(RomanEmpireSoundConfig.instance.RFB_LOCK)
                ]);
                this._timeline.add([
                    this._view.getBlastAnim(pos, 0xFAA501),
                    () => SoundManager.playSound(RomanEmpireSoundConfig.instance.RFB_LOCK_EXPLODE)
                ]);
                this._timeline.add([
                    this.convertM2M3intoWild(this._m2m3Pos),
                    ()=> SoundManager.playSound(RomanEmpireSoundConfig.instance.RFB_WILDS)
                ], "-=0.3");
                this._timeline.add(this._view.startPresentation(this._genieSymbolTriggerPositions, this._featureType, this._isReSpin, this._multiplierOverlays));
                this._timeline.add(() => this._view.dimSymbol(this._dimSymbolArr, false));
            }
            this._timeline.add("presentationComplete");
            this._finishTween = TweenLite.to({}, 0.00001, {
                onComplete: () => {
                    this.finish()
                }
            });
            this._timeline.add(this._finishTween);
            //this._timeline.add(() => this.finish());
            this._timeline.play(0);
        } else {
            this.finish();
        }
    }

    protected stopWinPresentation(isAborted: boolean): void {
        if (isAborted) {
            this._timeline.remove(this._finishTween);
            this._timeline.progress(100);
            //this._timeline.getLabelTime("presentationComplete")
            SoundManager.stopSound(RomanEmpireSoundConfig.instance.RFB_MULTI_CLOUD);
            SoundManager.stopSound(RomanEmpireSoundConfig.instance.RFB_MULTI_CLOUD_EXPLODE);
        }
        if (this._timeline && this._timeline.isActive()) {
            this._timeline.pause().kill();
        }
        this._view.stopPresentation(isAborted);
    }

    /**
     * To set multiplier overlay wilds array from server response.
     * @param reelArr
     */
    private setM2M3Pos(reelArr: string[][]) {
        this._m2m3Pos.length = 0;
        this._dimSymbolArr.length = 0;
        reelArr.forEach((position: string[], colIndex: number) => {
            position.forEach((value: string, rowIndex: number) => {
                if (value === "M2" || value === "M3") {
                    this._m2m3Pos.push({
                        reelId: colIndex,
                        symbolId: rowIndex
                    })
                } else {
                    this._dimSymbolArr.push({
                        reelId: colIndex,
                        symbolId: rowIndex
                    });
                }
            });
        })
    }


    /**
     * To set multiplier overlay wilds array from server response.
     * @param multiplierOverlays
     */
    private setMultiplierOverlays(overlayArr: number[][]) {
        this._multiplierOverlays.length = 0;
        overlayArr.forEach((position: number[], colIndex: number) => {
            position.forEach((value: number, rowIndex: number) => {
                value && this._multiplierOverlays.push({
                    reelId: colIndex,
                    symbolId: rowIndex,
                    value: value,
                    isDisabled: !this._symbolWinStates[colIndex][rowIndex]
                })
            });
        })
    }

    /**
     * To set genie overlay wilds array from server response.
     * @param overlayWilds
     */
    private setGenieOverlayWilds(overlayWilds: boolean[][], triggeredPos: boolean[][]) {
        overlayWilds.forEach((position: boolean[], colIndex: number) => {
            position.forEach((value: boolean, rowIndex: number) => {
                value && !triggeredPos[colIndex][rowIndex] && this._genieOverlayWilds.push({
                    reelId: colIndex,
                    symbolId: rowIndex
                })
            });
        })
    }

    /**
     * To set Genie symbol trigger position array
     * @param positions
     */
    private setTriggeredPositions(positions: boolean[][]) {
        positions?.forEach((pos, reelId) => {
            pos.forEach((value, symbolId) => {
                value && (this._genieSymbolTriggerPositions.push({reelId: reelId, symbolId: symbolId}));
            });
        });
    }

}